<template>
	<v-row
		dense
		:style="{ 'max-height': roleIsSystemAdmin ? 'calc(100vh - 115px) !important' : 'calc(100vh - 60px) !important' }"
		class="pa-2 ma-0">
		<v-dialog v-model="dialog" max-width="350">
			<v-card>
				<v-card-title
					class="font-size16 white--text my-0 py-0"
					style="background-color: #a51717; height: 40px !important">
					{{ $t('create-resident') }}
				</v-card-title>
				<v-card-text class="font-size15 d-flex flex-column mt-2">
					{{ $t('are-you-sure-the-resident') }} "{{ resident?.residentFirstName }} {{ resident?.residentLastName }}"
					{{ $t('is-not-mapped') }} ?
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn small @click="dialog = false">
						{{ $t('cancel') }}
					</v-btn>
					<v-btn class="white--text" small color="chips" @click="confirmCreate">
						{{ $t('create') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="deleteDialog" max-width="350">
			<v-card>
				<v-card-title
					class="font-size16 white--text my-0 py-0"
					style="background-color: #a51717; height: 40px !important">
					{{ $t('delete-ecp-resident-mapping') }}
				</v-card-title>
				<v-card-text class="font-size15 d-flex flex-column mt-2">
					{{ $t('are-you-sure-you-want-to-delete-this-resident-mapping') }}?
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn small @click="deleteDialog = false">
						{{ $t('cancel') }}
					</v-btn>
					<v-btn class="white--text" small color="chips" @click="confirmDeletion">
						{{ $t('delete') }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- TODO:  With Update Table -->
		<v-col
			cols="6"
			:style="{
				height: selectedEcpUser !== null && selectedNotMappedUser !== null ? 'calc((100vh - 129px) / 2)' : '50%',
			}">
			<v-card elevation="5" height="100%" ref="ecpUsersTable" @resize="updateDataTableHeight">
				<div class="d-flex justify-space-between elevation-3">
					<div class="d-flex align-center">
						<v-img :src="ecp" class="ml-2" max-height="21" max-width="22" />
						<div class="text-left ml-2 font-weight-bold font-size16">
							{{ $t('unmapped-users-from-ecp') }}
						</div>
					</div>
					<div>
						<v-text-field
							single-line
							outlined
							class="pa-1"
							prepend-inner-icon="mdi-magnify"
							hide-details
							dense
							v-model="searchEcpPatient"
							:label="$t('search')" />
					</div>
				</div>
				<v-divider />
				<v-radio-group class="small ma-0 pa-0" v-model="selectedEcpUser">
					<v-data-table
						:loading="loading"
						:headers="ecpHeaders"
						:items="items.usersNeedToBeMapped"
						:search="searchEcpPatient"
						:height="tableHeight"
						fixed-header
						:footer-props="getDataTableFooterProps('residentMappingTable')"
						:items-per-page="-1"
						:no-data-text="$t('no-data-available')">
						<template v-slot:item="{ item, index }">
							<tr :class="getRowsForDataTable(index)">
								<v-tooltip color="primary" bottom>
									<template v-slot:activator="{ on, attrs }">
										<td style="height: 30px !important" class="table-font-size px-2 py-0" v-bind="attrs" v-on="on">
											<div class="d-flex">
												<v-icon
													style="font-size: 12px !important"
													class="mr-1"
													x-small
													:class="getStatusIcons(item.residentStatus)">
													mdi-checkbox-blank-circle
												</v-icon>
												<v-img class="mr-2" :src="PatientBlack" max-width="13px" max-height="20px" />
												{{ item.residentFirstName }} {{ item.residentLastName }}
											</div>
										</td>
									</template>
									<span>{{ item?.residentStatusDescription || '' }}</span>
								</v-tooltip>
								<td style="height: 30px !important" class="table-font-size px-2 py-0">
									<v-chip label pill x-small color="primary">
										{{ calculateAge(item.residentBirthDate) }}
									</v-chip>
								</td>
								<td style="height: 30px !important" class="table-font-size px-2 py-0">
									{{ formatTimestamp(item.residentBirthDate.split('T')[0]) }}
								</td>
								<td style="height: 30px !important" class="table-font-size px-2 py-0">{{ item.residentGender }}</td>
								<td
									style="height: 30px !important"
									class="table-font-size pl-8 py-0 d-flex justify-center align-center">
									<v-tooltip bottom v-if="item.residentMapSuggestion?.score >= 5">
										<template v-slot:activator="{ on, attrs }">
											<div v-bind="attrs" v-on="on" class="d-flex align-center">
												<v-radio :value="item" @click="clickResidentNeedToBeMap(item)" />
											</div>
										</template>

										<!-- Tooltip content -->
										<div class="pa-2 text-left" style="max-width: 300px; white-space: normal">
											<strong>{{ $t('suggested-to-map-with') }}:</strong><br /><br />
											<span>{{ item.residentMapSuggestion.localUserFullName }}</span>
											<div>{{ $t('dob') }}: {{ item.residentMapSuggestion.localUserBirthdate }}</div>
											<div v-if="item.residentMapSuggestion.evidence?.length">
												<span>{{ $t('evidence') }}:</span>
												<ul class="ma-0 pa-0 pl-4">
													<li v-for="(ev, idx) in item.residentMapSuggestion.evidence" :key="idx">
														{{ ev }}
													</li>
												</ul>
											</div>
										</div>
									</v-tooltip>

									<v-btn v-else x-small color="primary" class="text-capitalize" @click="createResident(item)">
										{{ $t('create') }}
									</v-btn>
								</td>
							</tr>
						</template>
					</v-data-table>
				</v-radio-group>
			</v-card>
		</v-col>
		<!-- TODO:  Not Mapped Table -->
		<v-col
			cols="6"
			:style="{
				height: selectedEcpUser !== null && selectedNotMappedUser !== null ? 'calc((100vh - 129px) / 2)' : '50%',
			}">
			<v-card elevation="5" height="100%">
				<div class="d-flex justify-space-between elevation-3">
					<div class="d-flex align-center">
						<v-img :src="logoDrawer" class="ml-2" max-height="21" max-width="22" />
						<div class="text-left ml-2 font-weight-bold font-size16">{{ $t('unmapped-patients') }}</div>
					</div>
					<div>
						<v-text-field
							single-line
							outlined
							class="py-1 px-1"
							prepend-inner-icon="mdi-magnify"
							hide-details
							dense
							v-model="searchNotMappedPatient"
							:label="$t('search')" />
					</div>
				</div>
				<v-divider />
				<v-radio-group v-model="selectedNotMappedUser" class="small ma-0 pa-0">
					<v-data-table
						:loading="loading"
						:headers="notMappedPatientsHeaders"
						:items="items.notMappedUsers"
						:search="searchNotMappedPatient"
						:height="tableHeight"
						fixed-header
						:footer-props="getDataTableFooterProps('residentMappingTable')"
						:items-per-page="-1"
						:no-data-text="$t('no-data-available')">
						<template v-slot:item="{ item }">
							<tr :ref="(el) => setRowRef(item.id, el)" :class="{ 'highlight-row': highlightedId === item.id }">
								<td style="height: 30px !important" class="table-font-size px-2 py-0">
									<div class="d-flex align-center">
										<div class="d-flex align-center" style="min-width: 80px">
											<v-chip class="mr-5" x-small hide-details :color="getColorStatus(item.status)">
												{{ getStatus(item.status) }}
											</v-chip>
										</div>
										<div>
											<span>{{ item.firstName }} {{ item.lastName }}</span>
										</div>
									</div>
								</td>
								<td style="height: 30px !important" class="table-font-size px-2 py-0">
									<v-chip label pill x-small color="primary"> {{ calculateAge(item.birthdate) }}</v-chip>
								</td>
								<td style="height: 30px !important" class="table-font-size px-2 py-0">
									{{ formatTimestamp(item.birthdate) }}
								</td>
								<td style="height: 30px !important" class="table-font-size px-2 py-0">
									{{ item.gender === 'F' ? $t('female') : $t('male') }}
								</td>
								<td style="height: 30px !important" class="table-font-size pl-8 py-0">
									<v-radio :value="item"></v-radio>
								</td>
							</tr>
						</template>
					</v-data-table>
				</v-radio-group>
			</v-card>
		</v-col>
		<v-col
			cols="12"
			class="py-2"
			v-if="selectedEcpUser !== null && selectedNotMappedUser !== null"
			style="height: 52px">
			<v-btn @click="mapUser" color="primary2" block>
				<span style="text-transform: capitalize" class="font-size15 white--text">Map User</span>
			</v-btn>
		</v-col>
		<!--   TODO: MAPPED USERS   -->
		<v-col
			cols="12"
			:style="{
				height: selectedEcpUser !== null && selectedNotMappedUser !== null ? 'calc((100vh - 129px) / 2)' : '50%',
			}">
			<v-card elevation="5" height="100%">
				<div class="d-flex justify-space-between elevation-3">
					<div class="d-flex align-center">
						<v-img class="ml-2" :src="PatientBlack" max-width="13px" max-height="20px" />
						<div class="text-left ml-2 font-weight-bold font-size16">{{ $t('mapped-patients') }}</div>
					</div>
					<div>
						<v-text-field
							single-line
							outlined
							class="py-1 px-1"
							prepend-inner-icon="mdi-magnify"
							hide-details
							dense
							v-model="searchMappedPatient"
							:label="$t('search')" />
					</div>
				</div>
				<v-divider />
				<v-data-table
					:loading="loading"
					:headers="staffHeaders"
					:items="items.mappedUsers"
					:search="searchMappedPatient"
					:height="tableHeight"
					fixed-header
					:footer-props="getDataTableFooterProps('residentMappingTable')"
					:items-per-page="-1"
					:no-data-text="$t('no-data-available')">
					<template v-slot:item="{ item, index }">
						<tr :class="getRowsForDataTable(index)">
							<td style="height: 30px !important" class="table-font-size px-2 py-0">
								<div class="d-flex align-center">
									<div class="d-flex align-center" style="min-width: 80px">
										<v-chip x-small hide-details :color="getColorStatus(item.status)">
											{{ getStatus(item.status) }}
										</v-chip>
									</div>
									<div>
										<span>{{ item.firstName }} {{ item.lastName }}</span>
									</div>
								</div>
							</td>
							<td style="height: 30px !important" class="table-font-size px-2 py-0">
								<div class="d-flex align-center">
									<span>{{ item?.ecpLocationId }}</span>
								</div>
							</td>
							<td style="height: 30px !important" class="table-font-size px-2 py-0">
								<v-chip label pill x-small color="primary"> {{ calculateAge(item.birthdate) }}</v-chip>
							</td>
							<td style="height: 30px !important" class="table-font-size px-2 py-0">
								{{ formatTimestamp(item.birthdate) }}
							</td>
							<td style="height: 30px !important" class="table-font-size px-2 py-0">
								{{ item.gender === 'M' ? $t('male') : $t('female') }}
							</td>
							<td style="height: 30px !important" class="table-font-size text-left pl-8 py-0">
								<v-icon @click="openDeleteDialog(item)" size="18" color="primary">mdi mdi-delete</v-icon>
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-card>
		</v-col>
	</v-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { ecp, patientBlack, logoDrawer } from '@/assets';
import MappingRepository from '@/data/repositories/v1/MappingRepository.js';
import UsersRepository from '@/data/repositories/v1/UsersRepository.js';
import { getDataTableFooterProps, calculateAge, getRowsForDataTable, formatTimestamp } from '../../../utils/utilities';
import { ref } from 'vue';

const rowRefs = ref({});

export default {
	data () {
		return {
			dialog: false,
			deleteDialog: false,
			resident: null,
			patientToDelete: null,
			PatientBlack: patientBlack,
			loading: false,
			openDialog: false,
			selectedEcpUser: null,
			selectedNotMappedUser: null,
			searchEcpPatient: '',
			searchNotMappedPatient: '',
			searchMappedPatient: '',

			items: {
				notMappedUsers: [],
				mappedUsers: [],
				usersNeedToBeMapped: [],
			},
			ecpHeaders: [
				{ text: this.$t('patient-name'), value: 'residentFirstName', class: 'px-0 py-0 pl-2 height15-black' },
				{ text: this.$t('age'), value: 'birthdate', class: 'px-0 py-0 pl-4  height15-black' },
				{ text: this.$t('birthdate'), value: 'residentBirthDate', class: 'px-0 py-0 pl-2 height15-black' },
				{ text: this.$t('gender'), value: 'residentGender', class: 'px-0 py-0 pl-2 height15-black' },
				{ text: '', value: '', class: 'px-0 py-0 height15-black', width: '50' },
			],
			staffHeaders: [
				{ text: this.$t('patient-name'), value: 'firstName', class: 'px-0 py-0 pl-2 height15-black', width: '400' },
				{ text: this.$t('ecp-location-id'), value: 'ecpLocationId', class: 'px-0 py-0 pl-2 height15-black' },
				{ text: this.$t('age'), value: 'birthdate', class: 'px-0 py-0 pl-3 height15-black' },
				{ text: this.$t('birthdate'), value: 'birthdate', class: 'px-0 py-0 pl-2 height15-black' },
				{ text: this.$t('gender'), value: 'gender', class: 'px-0 py-0 pl-2 height15-black' },
				{ text: '', value: '', class: 'px-0 py-0 height15-black', width: '50' },
			],
			notMappedPatientsHeaders: [
				{ text: this.$t('patient-name'), value: 'firstName', class: 'px-0 py-0 pl-2 height15-black' },
				{ text: this.$t('age'), value: 'birthdate', class: 'px-0 py-0 pl-3 height15-black' },
				{ text: this.$t('birthdate'), value: 'birthdate', class: 'px-0 py-0 pl-2 height15-black' },
				{ text: this.$t('gender'), value: 'gender', class: 'px-0 py-0 pl-2 height15-black' },
				{ text: '', value: '', class: 'px-0 py-0 height15-black', width: '50' },
			],
			highlightedId: null,
			tableHeight: '300px',
		};
	},
	computed: {
		logoDrawer () {
			return logoDrawer;
		},
		ecp () {
			return ecp;
		},
		...mapState({
			userData: (state) => state.authentication.userData,
			selectedHospitalId: (state) => state.filterbar.hospitalId,
			medicalInstitution: (state) => state.filterbar.medicalInstitution,
		}),
		...mapGetters({
			roleName: 'authentication/getRole',
			userSettings: 'authentication/getUserSettings',
		}),
		roleIsSystemAdmin () {
			return this.roleName === 'SYSTEM_ADMIN' || this.roleName === 'SYSTEM_USER';
		},
	},
	created () {
		this.getECPUsersMappings();
		window.addEventListener('resize', this.updateDataTableHeight);
	},
	mounted () {
		setTimeout(() => {
			this.updateDataTableHeight();
		}, 100);
	},
	watch: {
		selectedHospitalId: {
			handler () {
				this.getECPUsersMappings();
			},
			deep: true,
		},
		selectedEcpUser (newVal, oldVal) {
			if (oldVal === null && newVal !== null) {
				this.updateDataTableHeight();
			}
		},
		selectedNotMappedUser (newVal, oldVal) {
			if (oldVal === null && newVal !== null) {
				this.updateDataTableHeight();
			}
		},
	},
	methods: {
		formatTimestamp,
		scrollToRow (desiredId) {
			const el = rowRefs.value[desiredId];
			if (el) {
				el.scrollIntoView({
					behavior: 'smooth',
					block: 'center',
				});

				// set highlight
				this.highlightedId = desiredId;
			}
		},
		setRowRef (id, el) {
			if (el) {
				rowRefs.value[id] = el;
			}
		},
		clickResidentNeedToBeMap (item) {
			const suggestionWithNotMappedResident = this.items.notMappedUsers.find(
				(p) => p.id === this.selectedEcpUser.residentMapSuggestion.localUserId,
			);

			this.selectedNotMappedUser = suggestionWithNotMappedResident;
			this.scrollToRow(suggestionWithNotMappedResident.residentMapSuggestion.localUserId);
		},
		getECPUsersMappings () {
			switch (this.roleName) {
				case 'SYSTEM_ADMIN':
					if (this.selectedHospitalId !== null) {
						this.getUsersForMapping();
					}
					return;
				case 'SYSTEM_USER':
					if (this.selectedHospitalId !== null) {
						this.getUsersForMapping();
					}
					return;
				case 'HOSPITAL_ADMIN':
					this.getUsersForMapping();
					break;
				case 'DOCTOR':
					this.getUsersForMapping();
					break;
				case 'NURSE':
					this.getUsersForMapping();
					break;
			}
		},
		getColorStatus (status) {
			switch (status) {
				case 1:
					return 'background-green-dot-status';
				case 0:
					return 'grey';
				case 10:
					return 'background-red-dot-status';
				case 99:
					return 'background-black-dot-status';
			}
		},
		getStatus (status) {
			switch (status) {
				case 1:
					return this.$t('active');
				case 0:
					return this.$t('inactive');
				case -1:
					return this.$t('pending');
				case 10:
					return this.$t('deleted');
				case 99:
					return this.$t('deceased');
			}
		},
		calculateAge,
		getRowsForDataTable,
		getDataTableFooterProps,
		openDeleteDialog (item) {
			this.deleteDialog = true;
			this.patientToDelete = item.id;
		},
		confirmDeletion () {
			MappingRepository.deleteMappedUser(this.patientToDelete).then(() => {
				this.getUsersForMapping();
				this.searchEcpPatient = '';
				this.searchNotMappedPatient = '';
				this.searchMappedPatient = '';
				this.selectedNotMappedUser = null;
				this.selectedEcpUser = null;
				this.deleteDialog = false;
			});
		},
		getStatusIcons (status) {
			switch (status) {
				case 'Active':
					return 'color-green';
				default:
					return '';
			}
		},
		confirmCreate () {
			UsersRepository.createResident(this.resident.id).then(() => {
				this.getUsersForMapping();
				this.dialog = false;
			});
		},
		createResident (item) {
			this.dialog = true;
			this.resident = item;
		},
		getUsersForMapping () {
			this.loading = true;
			let selectedHospitalId = null;
			if (this.roleName === 'HOSPITAL_ADMIN') {
				selectedHospitalId = this.userData.hospitalAssignedData.id;
			} else if (this.roleName === 'DOCTOR' || this.roleName === 'NURSE') {
				selectedHospitalId = Number(localStorage.getItem('selectedHospitalAssignedId')) || 0;
			} else {
				selectedHospitalId = this.selectedHospitalId;
			}

			MappingRepository.getMappedEcpUsersForHospital(selectedHospitalId).then((response) => {
				this.items = response || [];
				this.loading = false;
			});
		},
		mapUser () {
			this.loading = true;
			let selectedHospitalId = null;
			let selectedOrganizationId = null;

			if (this.roleName === 'HOSPITAL_ADMIN') {
				selectedHospitalId = this.userData.hospitalAssignedData.id;
				selectedOrganizationId = this.userData.organizationId;
			} else if (this.roleName === 'DOCTOR' || this.roleName === 'NURSE') {
				selectedHospitalId = Number(localStorage.getItem('selectedHospitalAssignedId')) || 0;
				selectedOrganizationId = this.userData.organizationId;
			} else {
				selectedHospitalId = this.selectedHospitalId;
				selectedOrganizationId = this.medicalInstitution;
			}

			const body = {
				ecpUserId: this.selectedEcpUser?.residentId || 'string',
				ecpLocationId: this.selectedEcpUser?.ecpLocationId || null,
				mappedUserId: this.selectedNotMappedUser?.id || 0,
				mappedHospitalId: selectedHospitalId,
				mappedOrganizationId: selectedOrganizationId,
				firstName: this.selectedEcpUser?.residentFirstName,
				lastName: this.selectedEcpUser?.residentLastName,
				birthdate: this.selectedEcpUser?.residentBirthDate,
			};

			MappingRepository.mapUser(body).then((response) => {
				if (response.resFlag) {
					this.getUsersForMapping();
					this.selectedNotMappedUser = null;
					this.selectedEcpUser = null;
					this.searchEcpPatient = '';
					this.searchNotMappedPatient = '';
					this.searchMappedPatient = '';
				} else this.loading = false;
			});
		},
		deleteMappedUser (item) {
			MappingRepository.deleteMappedUser(item.id).then(() => {
				this.getUsersForMapping();
				this.searchEcpPatient = '';
				this.searchNotMappedPatient = '';
				this.searchMappedPatient = '';
				this.selectedNotMappedUser = null;
				this.selectedEcpUser = null;
			});
		},
		updateDataTableHeight () {
			this.$nextTick(() => {
				if (this.$refs.ecpUsersTable) {
					this.tableHeight = this.$refs.ecpUsersTable.$el.clientHeight - 109 + 'px';
				}
			});
		},
	},
};
</script>

<style lang="scss">
.v-messages {
	display: none !important;
}

.small i {
	font-size: 18px !important;
}

.small [class*='__ripple'] {
	left: 0;
	display: none;
}

.highlight-row {
	animation: blink-bg 1s ease-in-out infinite;
}

@keyframes blink-bg {
	0%,
	100% {
		background-color: transparent;
	}

	50% {
		background-color: #d1d1d1;
	}
}
</style>
